import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=bfa89d7c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=bfa89d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa89d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa89d7c')) {
      api.createRecord('bfa89d7c', component.options)
    } else {
      api.reload('bfa89d7c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=bfa89d7c&scoped=true&", function () {
      api.rerender('bfa89d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gy0OAKwBIgg4/JS/comp/PopupDialog.vue"
export default component.exports